const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 16277",
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.195,
    height: 123.867,
    viewBox: "0 0 119.195 123.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lkf4x4m9xa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10949",
    style: {
      fill: "none"
    },
    d: "M0 0h119.195v123.867H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sbt60kmzjb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10947",
    style: {
      fill: "none"
    },
    d: "M0 0h8.224v22.756H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16276",
    style: {
      clipPath: "url(#lkf4x4m9xa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16275"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16274",
    style: {
      clipPath: "url(#lkf4x4m9xa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35024",
    d: "M4.358 121.708A309.345 309.345 0 0 1 0 69.944c.11-28.155 11.3-45.882 23.045-50.253 23.429-8.72 32.2 6.508 41.481 21.748 2.25 3.7 9.189 15.089 20.989 17.621 7.856 1.686 13.095-1.576 18.4 2.332 1.444 1.064 4.591 3.912 5.96 12.7 2.845 18.253-6.691 39.251-11.155 47.618z",
    transform: "translate(0 1.299)",
    style: {
      fill: "#e5e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35025",
    d: "M54.089 21.307c-.417 1.548 3.492 2.481 8.073 8.213s3.346 8.146 7.249 13.968c1.432 2.136 6.529 9.737 15.744 12.1 1.145.293 11.578 2.857 14.933-1.72 4.254-5.8-3.692-21.964-16.167-29.59C71.2 16.506 54.9 18.289 54.089 21.307",
    transform: "translate(1.585 .549)",
    style: {
      fill: "#e5e9ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3855",
    cx: 22.095,
    cy: 22.095,
    r: 22.095,
    transform: "translate(16.28 .514)",
    style: {
      stroke: "#534987",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "12 4 4 2 3 2",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35026",
    d: "m12.353 99.906 1.054-2.657h40.2v2.657z",
    transform: "translate(.362 2.851)",
    style: {
      fill: "#88939c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10938",
    transform: "translate(51.689 60.251)",
    style: {
      fill: "#bcc5d1"
    },
    d: "M0 0h16.998v35.542H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10939",
    transform: "translate(60.342 94.33)",
    style: {
      fill: "#afb9c7"
    },
    d: "M0 0h32.25v29.537H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35027",
    d: "m58.806 91.722-6.376-2.761v28.492l6.376 3.806z",
    transform: "translate(1.537 2.608)",
    style: {
      fill: "#98a2ab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35028",
    d: "m91.056 91.746-7.68-2.146-27.731-1.43-3.215.816 6.376 2.762z",
    transform: "translate(1.537 2.584)",
    style: {
      fill: "#88939c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10940",
    transform: "translate(62.357 72.177)",
    style: {
      fill: "#bcc5d1"
    },
    d: "M0 0h22.555v20.005H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35029",
    d: "m83.284 70.14-12.775-.64H55.553l5.175.636z",
    transform: "translate(1.628 2.037)",
    style: {
      fill: "#a2adba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35030",
    d: "M55.553 69.5v19.215l5.174 1.429v-20z",
    transform: "translate(1.628 2.037)",
    style: {
      fill: "#98a2ab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35031",
    d: "m45.027 60.051 5.342-1.516v26.587l-5.342-.407z",
    transform: "translate(1.32 1.716)",
    style: {
      fill: "#a2adba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10941",
    transform: "translate(12.715 102.756)",
    style: {
      fill: "#afb9c7"
    },
    d: "M0 0h44.987v20.251H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10942",
    transform: "translate(17.553 84.258)",
    style: {
      fill: "#ced7e0"
    },
    d: "M0 0h36.414v17.199H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10943",
    transform: "translate(24.286 62.875)",
    style: {
      fill: "#afb9c7"
    },
    d: "M0 0h22.061v21.384H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10944",
    transform: "translate(25.195 54.14)",
    style: {
      fill: "#bfc7d1"
    },
    d: "M0 0h18.836v8.736H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35032",
    d: "m23.666 61.085-2.51 1.188v20.2h2.51z",
    transform: "translate(.62 1.79)",
    style: {
      fill: "#a2adba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10945",
    transform: "translate(69.856 72.177)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h5.844v5.844H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10946",
    transform: "translate(12.715 110.015)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h26.079v4.392H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35033",
    d: "M92.007 117.9a3.775 3.775 0 0 0 2.56 1.089c1.312.11 3.676.622 4.758-.031s1.7-1.032 2.509-.763a4.168 4.168 0 0 0 2.426.013c1.04-.209 3.122-.922 3.122-.922a5.327 5.327 0 0 0-.383-1.857 3.76 3.76 0 0 0-.862-.659S94.641 117 93.7 116.937s-1.108.175-1.108.175z",
    transform: "translate(2.697 3.364)",
    style: {
      fill: "#212e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35034",
    d: "M101.054 109.143s-1.154 3.375-2.246 4.5-1.94 2.193-2.929 2.489-2.095-.212-2.717.4l-.411.573-.172.241s.329.632 2.914.3 5.8-1.033 7.274-1.279a34.747 34.747 0 0 0 3.92-1.057s.029-.458-.636-1.238-.85-3.169-1.133-3.7a28.734 28.734 0 0 1-.846-3.507z",
    transform: "translate(2.714 3.132)",
    style: {
      fill: "#212e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35035",
    d: "M72.093 108.781a3.778 3.778 0 0 0 1.074 2.566c.865 1 2.2 3.011 3.43 3.3s1.939.445 2.33 1.2a4.169 4.169 0 0 0 1.728 1.7c.89.575 2.88 1.518 2.88 1.518s.993-1.14 1.022-1.6a3.786 3.786 0 0 0-.157-1.065s-9.8-6.421-10.422-7.122-.915-.647-.915-.647z",
    transform: "translate(2.112 3.184)",
    style: {
      fill: "#212e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35036",
    d: "M84.828 108.676s-3.182 1.613-4.75 1.656-2.92.218-3.835-.261-1.351-1.613-2.223-1.613l-.694.126-.291.052s-.2.682 1.875 2.25 4.876 3.307 6.1 4.159a34.633 34.633 0 0 0 3.546 1.977 2.024 2.024 0 0 0 .409-1.329c.068-1.023 1.6-2.865 1.772-3.444a28.741 28.741 0 0 1 1.841-3.1z",
    transform: "translate(2.141 3.179)",
    style: {
      fill: "#212e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35037",
    d: "M94.1 70.619s-5.3 13.822-5.448 14.215-1.23 8.755-1.82 12.1-3.492 11.411-4.378 12.542-.049 1.524 1.967 1.82a35.765 35.765 0 0 1 5.509 1.623 46.927 46.927 0 0 0 2.016-7.083c.492-3 1.329-6.837 1.869-8.8s4.23-9.493 4.968-11.018 4.151-15.235 4.151-15.235z",
    transform: "translate(2.407 2.07)",
    style: {
      fill: "#434963"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35038",
    d: "M100 91.9a73.077 73.077 0 0 1 .343 11.653 27.584 27.584 0 0 1-1.126 6.1c-.52 1.515-.953 2.6-.953 2.6a42.849 42.849 0 0 0 5.022.8c1.645.069 3.2 0 3.2 0a67.224 67.224 0 0 0 1.256-10.363c0-4.112.216-12.726 0-16.19a18.2 18.2 0 0 1 .1-5.411c.25-1.514 1.765-4.935 1.376-6.925s-.779-5.454-2.035-7.1-4.285 0-4.285 0S99.621 88.443 100 91.9",
    transform: "translate(2.88 1.944)",
    style: {
      fill: "#434963"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16273",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16272"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16271",
    style: {
      clipPath: "url(#sbt60kmzjb)"
    },
    transform: "translate(99.877 71.48)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35039",
    d: "M97.232 70.327s-.565 4.672.21 6.642.279 5.94 1.129 8.5a54.08 54.08 0 0 1 1.512 6.731l2.258-1.143 2.915-21.613z",
    transform: "translate(-97.033 -69.444)",
    style: {
      fill: "#303546"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35040",
    d: "M110.8 35.557s-.1 5.263.97 7.559 6 7.094 3.983 10.949-5.74 6.34-7.41 5.569-6.43-16.581-6.43-16.581l-.8-6.763 4.545-3.041z",
    transform: "translate(2.964 .975)",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35041",
    d: "M93.581 60.346a7.875 7.875 0 0 1-.183 1.823 7.779 7.779 0 0 1-.519.924l2.048.4.352-3.806z",
    transform: "translate(2.722 1.75)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35042",
    d: "M94.346 59.864a43.915 43.915 0 0 1 .209 4.7c-.111 1.146-1.9 6.925-1.9 6.925l2.767.84 2.148-3.911-.391-7.643z",
    transform: "translate(2.716 1.755)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35043",
    d: "M97.022 56.357s.444-1.835.772-3.036a20.829 20.829 0 0 1 1.148-3.511 48.869 48.869 0 0 1 2.816-4.366 33.91 33.91 0 0 1 4.011-2.909s2.144 1.261 2.724 1.664a8.813 8.813 0 0 1 2.22 1.68 11.651 11.651 0 0 1 .948 2.186c.262.567-4.194 17.342-4.194 17.342a8.372 8.372 0 0 0 .389 3.059c.519 1.459-8.075 4.246-9.921 4.376a12.384 12.384 0 0 1-2.592 0s.778-10.567 1.1-12.609.576-3.875.576-3.875",
    transform: "translate(2.795 1.247)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35044",
    d: "M100.088 43.838a5.611 5.611 0 0 0-2.177 1.562 8.9 8.9 0 0 0-1.66 3.347 15 15 0 0 0 0 3.462z",
    transform: "translate(2.818 1.285)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35045",
    d: "m99.637 44.436-2.568 4.079a26.4 26.4 0 0 0-2.178 4.385c-.285.959-.571 2.231-.571 2.231l2.413 2.485s1.244-5.194 1.737-6.589a10.632 10.632 0 0 1 .836-1.933l2.3-4.782z",
    transform: "translate(2.765 1.299)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35046",
    d: "M105.676 60.75s-.584-8.77-.641-10.4c-.079-2.242.227-3.136 1.637-4.273s2.545-1.091 3.454 0a7.813 7.813 0 0 1 1.953 4.455c-.043 1.5-.141 6.68-.141 6.68a28.7 28.7 0 0 1 .075 5.384 25.9 25.9 0 0 1-.668 2.732l-4.412-2z",
    transform: "translate(3.078 1.326)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35047",
    d: "m88.323 57.412-3.442-2.681.109-.4 9.764-.217 8.406 6.214-3.306.207h-6.313z",
    transform: "translate(2.488 1.586)",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35048",
    d: "M93.742 60.422a9.231 9.231 0 0 1-1.805-.468c-.452-.241-2.991-2.841-3.084-2.879a12.264 12.264 0 0 0-1.461.945 11.075 11.075 0 0 0 .595 2.219 8.776 8.776 0 0 0 1.283 1.222 5.789 5.789 0 0 1 1.866-.183 4.3 4.3 0 0 1 1.438 1.112 4.211 4.211 0 0 0 .632.594 4.123 4.123 0 0 0 .536-1.5v-1.056",
    transform: "translate(2.562 1.673)",
    style: {
      fill: "#b8a7d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35049",
    d: "M98.488 38.89a6.172 6.172 0 0 1 1.523 2.068 11.316 11.316 0 0 1 .675 3.483 4.338 4.338 0 0 1-.588 1.328l-.914 3.548 2.482-3.7a18.31 18.31 0 0 1 1.937-1.981l2.263-1.916a1.832 1.832 0 0 1-1.194-.942 37.929 37.929 0 0 1-.571-4.187z",
    transform: "translate(2.887 1.073)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35050",
    d: "m104.1 36.591-4.946 2.027-.612.322a6.083 6.083 0 0 1 1.469 2.018c.01.027.019.057.029.082a4.027 4.027 0 0 0 1.136-.667 30.106 30.106 0 0 0 2.924-3.782z",
    transform: "translate(2.888 1.073)",
    style: {
      fill: "#b6a2d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35051",
    d: "M102.572 30.941a19.022 19.022 0 0 1-2.3 1.908 52.993 52.993 0 0 1-2.116 1.117.446.446 0 0 0 .165.551l.316.192a16.8 16.8 0 0 0-1.059 2.023 1.8 1.8 0 0 1-.413.881c-.275.358-.689.88-.21 1.185s1.285.958 1.763.937a10.963 10.963 0 0 0 3.309-.675c1.5-.566 3.744-3.134 3.983-4.462s-.218-3.394-1.132-3.656a6.189 6.189 0 0 0-2.3 0",
    transform: "translate(2.835 .904)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35052",
    d: "M103.781 36.2s.762-.908 1.493-.26a.948.948 0 0 1-.261 1.627 9.674 9.674 0 0 1-2.264.794c-.3-.073-.855-1.419-.855-1.419z",
    transform: "translate(2.987 1.047)",
    style: {
      fill: "#d0bee6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35053",
    d: "M105.5 29.492s-2.432-.514-3.4.192a2.69 2.69 0 0 0-.855 2.844c.3.6 1.709 1.3 1.709 1.3l.962-.363-.492.684a5.3 5.3 0 0 0 1.176 1.031 11.493 11.493 0 0 0 3.058.71 14.751 14.751 0 0 0 3.144-.218c.022-.129-.107-2.374-1.155-3.336a40.092 40.092 0 0 0-4.148-2.844",
    transform: "translate(2.964 .859)",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35054",
    d: "m99.729 60.5-1.4-.108a2.477 2.477 0 0 0-.774-1.295 12.226 12.226 0 0 1-1.763-1.6c-.5-.558-1.08-.99-1.332-.774a.527.527 0 0 0 0 .81 7.271 7.271 0 0 1 .612.936s-1.746-.972-2.2-1.313-1.834-1.566-2.072-1.693-.846-.234-.757 0a22.589 22.589 0 0 0 1.566 1.818l1.224.828-1.201-.609s-1.062-1.011-1.332-1.3-1.116-.63-1.133-.45a7.481 7.481 0 0 0 1.224 1.835 6.642 6.642 0 0 0 1.745 1.583 17.786 17.786 0 0 1 2.311.832 21.307 21.307 0 0 1 1.908 1.326 15.187 15.187 0 0 0 2.2 1.264c.344.1 3.05 1.037 3.05 1.037z",
    transform: "translate(2.614 1.622)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35055",
    d: "M87.542 58.74a1.676 1.676 0 0 1-.11-.944 10.756 10.756 0 0 1 1.787-1.496s.162-.073.222.074a.718.718 0 0 1-.222.771c-.3.294-1.677 1.593-1.677 1.593",
    transform: "translate(2.562 1.65)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35056",
    d: "M87.588 59.624s-.194-.77-.049-.907a23.087 23.087 0 0 1 2.3-1.642c.135.012.613.208.221.612s-2.328 2.267-2.328 2.267z",
    transform: "translate(2.564 1.673)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35057",
    d: "M88.419 60.838s-.477-.515-.477-.735.674-.944 1.446-1.532a5.053 5.053 0 0 1 1.152-.724s.367-.024.22.307-2.342 2.683-2.342 2.683",
    transform: "translate(2.578 1.696)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35058",
    d: "M88.673 60.82a5.576 5.576 0 0 0 .969-.6c.171-.2 1.065-1.747 1.065-1.747s.429-.017.355.4a8.938 8.938 0 0 1-1.024 2.046c-.25.331-.838.589-.948.5a4.2 4.2 0 0 1-.417-.6",
    transform: "translate(2.599 1.714)",
    style: {
      fill: "#cdc1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35059",
    d: "M105.777 41.575a1.525 1.525 0 0 1 1.2.7c.326.654-.919 1.961-2 2.41a19.817 19.817 0 0 1-3.4.791 31.544 31.544 0 0 1 2.282-2.663c.469-.353 1.92-1.234 1.92-1.234",
    transform: "translate(2.977 1.219)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35060",
    d: "M100.523 42.835s-1.216.094-1.2.911a5.779 5.779 0 0 0 .857 2.123 9.1 9.1 0 0 0 .477-1.611c0-.347-.139-1.424-.139-1.424",
    transform: "translate(2.911 1.256)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35061",
    d: "M99.428 60.355s2.595-.1 4.456 0a22.011 22.011 0 0 0 2.979 0s3.164.757 3.686 2.534 2.2 2.745-.336 2.745-8.9-2.156-8.9-2.156z",
    transform: "translate(2.914 1.768)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35062",
    d: "M105.657 57.322s1.947-6.343 2.861-5.01 2.322 7.347 2.322 8.566-.087 3.278-.087 3.278l.572 1.072a11.305 11.305 0 0 0 .734-3.779c0-1.98-.267-6.777-.3-8a11.265 11.265 0 0 0-1.219-4c-.381-.571-1.979-1.288-2.893-.491s-1.371 2.2-1.714 3.994a25.093 25.093 0 0 0-.272 4.362",
    transform: "translate(3.097 1.425)",
    style: {
      fill: "#5245b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35063",
    d: "M55.405 21.786v1.324a2.726 2.726 0 0 0-.078.39 16.7 16.7 0 0 1-2.513 8.063 17.3 17.3 0 0 1-13.08 8.368c-.459.059-.918.1-1.378.157H37.18a4.693 4.693 0 0 0-.5-.08 16.849 16.849 0 0 1-6.186-1.536A17.6 17.6 0 0 1 38.8 4.88a16.921 16.921 0 0 1 7.72 2.307 17.342 17.342 0 0 1 8.73 13.295c.056.434.1.871.155 1.305m-16.056.687c.219-.173.324-.24.411-.325q1.885-1.881 3.767-3.764a1.207 1.207 0 0 0 .4-1.192 1.191 1.191 0 0 0-2.045-.546c-1.28 1.264-2.548 2.542-3.821 3.814-.092.093-.19.179-.353.33a2.475 2.475 0 0 0-.227-.321q-1.881-1.888-3.763-3.77a1.223 1.223 0 0 0-1.085-.417 1.2 1.2 0 0 0-.647 2.07q1.893 1.9 3.79 3.793c.094.094.182.191.285.3-.1.1-.179.194-.265.279-1.263 1.264-2.535 2.52-3.781 3.8a1.7 1.7 0 0 0-.422.82 1.186 1.186 0 0 0 2.038.926c1.286-1.276 2.565-2.561 3.847-3.84.093-.093.19-.179.339-.317a4.068 4.068 0 0 0 .268.336c1.244 1.25 2.482 2.505 3.746 3.733a1.772 1.772 0 0 0 .85.438 1.188 1.188 0 0 0 .9-2.048q-1.9-1.916-3.817-3.819a3.256 3.256 0 0 0-.418-.284",
    transform: "translate(.591 .142)",
    style: {
      fill: "#534987"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanCancel);
export default __webpack_public_path__ + "static/media/woman-cancel.6140f7fa426eab5d4661209fa232da1a.svg";
export { ForwardRef as ReactComponent };